// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1bGnf","header":"ReportDetails_header__3TYf-","title":"ReportDetails_title__3stT0","left":"ReportDetails_left__1yeRh"};